import { Form, InputNumber, Select } from 'antd'
import { SelectProps } from 'antd/es/select'
import React from 'react'
import styled from 'styled-components'

const MeasurementInputContainer = styled.div<{
  $unitWidth?: string
}>`
  display: grid;
  grid-template-columns: ${({ $unitWidth }) =>
    $unitWidth ? `minmax(0, 1fr) ${$unitWidth}` : '1fr 1fr'};
  width: 100%;
`

const StyledInputNumber = styled(InputNumber)<{
  $unitWidth?: string
}>`
  width: 100%;
  min-width: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`

const UnitSelect = styled(Select)<{
  $unitWidth?: string
}>`
  width: ${({ $unitWidth }) => $unitWidth ?? '50%'};
  height: 100%;

  .ant-select-selector {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    margin-left: -1px;
  }
`

interface UnitOption {
  value: string
  label: string
}

interface MeasurementInputProps {
  valueName: (string | number)[]
  unitName: (string | number)[]
  unitOptions: UnitOption[]
  placeholder?: string
  min?: number
  max?: number
  step?: number
  precision?: number
  defaultUnit?: string
  valueRules?: object[]
  unitRules?: object[]
  disabled?: boolean
  unitWidth?: string
}

// TODO: Add a shared component across the app
export const MeasurementInput: React.FC<MeasurementInputProps> = ({
  valueName,
  unitName,
  unitOptions,
  placeholder = 'Value',
  min,
  max,
  step,
  precision,
  defaultUnit,
  valueRules,
  unitRules,
  disabled = false,
  unitWidth,
}) => {
  return (
    <MeasurementInputContainer $unitWidth={unitWidth}>
      <Form.Item name={valueName} noStyle rules={valueRules}>
        <StyledInputNumber
          $unitWidth={unitWidth}
          placeholder={placeholder}
          min={min}
          max={max}
          step={step}
          precision={precision}
          disabled={disabled}
        />
      </Form.Item>
      <Form.Item
        name={unitName}
        noStyle
        initialValue={defaultUnit}
        rules={unitRules}>
        <UnitSelect
          $unitWidth={unitWidth}
          options={unitOptions as SelectProps['options']}
          disabled={disabled}
        />
      </Form.Item>
    </MeasurementInputContainer>
  )
}
